export default {
  originCity: 'Seleziona città di partenza',
  destinationCity: 'Seleziona città di arrivo',
  direct: 'Diretto',
  indirect: '1+ scali',
  getPrices: 'Trova prezzi',
  directAvailable: 'Volo diretto disponibile da',
}
